export default function About() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8 sm:py-12">
      <div className="text-xs font-mono uppercase tracking-widest text-red-500 mb-1">About</div>
      <h1 className="font-display text-3xl sm:text-5xl font-black uppercase text-white">Popless</h1>
      <p className="mt-4 text-slate-300 leading-relaxed">
        A daily audio guessing game for professional wrestling fans. Two rounds a day: guess the wrestler from the
        opening seconds of their entrance theme, then match a voice to the promo.
      </p>
      <h2 className="font-display text-2xl font-black uppercase mt-8 text-white">Legal Disclaimer</h2>
      <p className="mt-3 text-slate-400 text-sm leading-relaxed">
        Popless is an unofficial fan trivia game and is not affiliated with, endorsed, or sponsored by WWE, AEW,
        Impact Wrestling, or any professional wrestling organization. All logos, entrance themes, promo audio,
        and images used within the game are the property of their respective owners and are managed solely by the
        site operator. Popless does not automatically download or scrape copyrighted material.
      </p>
      <h2 className="font-display text-2xl font-black uppercase mt-8 text-white">Audio Attribution</h2>
      <p className="mt-3 text-slate-400 text-sm leading-relaxed">
        Some puzzles play audio embedded via SoundCloud's official Widget API. Audio remains hosted by
        SoundCloud and its uploaders; Popless never downloads, records, or rehosts SoundCloud tracks.
        Track titles, uploader attribution, and SoundCloud branding are shown by the official widget
        as required by SoundCloud's terms. Popless is not affiliated with, endorsed, or sponsored by
        SoundCloud.
      </p>
      <h2 className="font-display text-2xl font-black uppercase mt-8 text-white">Privacy</h2>
      <p className="mt-3 text-slate-400 text-sm leading-relaxed">
        Guest progress is stored locally on your device. Accounts sync stats and streaks across devices.
        We never share your email.
      </p>
    </div>
  );
}
